export const useLocalStorage = () => {
  const set = (key: string, value: any) => {
    if (typeof window === 'undefined') {
      return;
    }

    try {
      localStorage.setItem(key, JSON.stringify(value));
    } catch (err) {
      console.error('Can not save to localStorage', err.message);
    }
  };

  const get = (key: string) => {
    if (typeof window === 'undefined') {
      return null;
    }

    const value = localStorage.getItem(key);

    try {
      return JSON.parse(value);
    } catch (err) {
      return value;
    }
  };

  const clear = (key: string) => {
    if (typeof window === 'undefined') {
      return;
    }

    localStorage.removeItem(key);
  };

  return {
    get,
    set,
    clear,
  };
};
